import constate from 'constate'

/** Context provider for gallery constant values */
export const [GalleryContextProvider, useGallery] = constate(({ assignmentId }: { assignmentId: string }) => {
  return {
    assignmentId
  }
})
